import { Container, Grid } from "@mui/material";
import React, { useState } from "react";
import TopBar from "../../../components/TopBar/TopBar";
import TreatmentBundle from "./TreatmentBundle";
import TreatmentPlan from "./TreatmentPlan";

const Plan = () => {
  const [selectedTab, setSelectedTab] = useState("TreatmentBundle");

  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <>
      <TopBar>
        <Container maxWidth="xl">
          <Grid container spacing={0}>
            <div className="flex-row">
              <div
                className="ph10pv3"
                onClick={() => {
                  handleSelectedTab("TreatmentBundle");
                }}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "TreatmentBundle"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Treatment Bundle
                </div>
              </div>
              {/* <div
                className="ph10pv3"
                onClick={() => handleSelectedTab("TreatmentPlan")}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "TreatmentPlan"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Treatment Plan
                </div>
              </div> */}
            </div>
          </Grid>
        </Container>
      </TopBar>
      <div className="left-con-white-wh mt10">
        {selectedTab === "TreatmentBundle" ? <TreatmentBundle /> : null}
        {selectedTab === "TreatmentPlan" ? <TreatmentPlan /> : null}
      </div>
    </>
  );
};

export default Plan;
